import React from 'react';
import { logoPropTypes } from './LogoPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Logo.module.scss';
const Logo = ({
  href,
  title,
  classname
}) => {
  if (!href || !title) {
    return null;
  }
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    title: title,
    className: `${styles.root} ${classname || ''}`
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "v4_logo",
    size: {
      width: 140,
      height: 35
    },
    classname: styles.rootIcon
  }));
};
export default Logo;